module.exports = __webpack_public_path__ + "static/media/mode-toggle-small.38e0e770.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/static/images/mode-toggle-small.gif
 ** module id = 332
 ** module chunks = 0
 **/